import basePageFields from '@fragments/pages/basePageFields';

export default gql`
    fragment ExpertsLandingFragment on ExpertsLanding {
        ${basePageFields}
        dek
    }
`;
